export default "__VITE_ASSET__55d6d22b__"